import '@material/web/button/outlined-button';

import { AsyncPipe, NgStyle } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { BehaviorSubject, Observable, of, switchMap, tap } from 'rxjs';

import { CardWithRadioButtonComponent } from '../card-with-radio-button/card-with-radio-button.component';
import { SurveyAndOfferComponent } from '../survey-and-offer/survey-and-offer.component';
import { AnswerOfferEvent } from '../types/events';
import { QPilotScheduledOrder } from '../types/scheduled-order';
import { QPilotActionTriggerTypes, QPilotOfferApplicableItem, QPilotSurvey } from '../types/surveys';

@Component({
  selector: 'lib-cancel-order',
  standalone: true,
  imports: [
    MatCardModule,
    MatRadioModule,
    FormsModule,
    NgStyle,
    AsyncPipe,
    SurveyAndOfferComponent,
    CardWithRadioButtonComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './cancel-order.component.html',
  styleUrl: './cancel-order.component.scss'
})
export class CancelOrderComponent implements OnInit {
  @Input() order: QPilotScheduledOrder;
  @Input() orderVerboseName: string;
  @Input() nextOccurrenceVerboseName: string;
  @Input() cancelSurvey$: Observable<QPilotSurvey>;

  @Output() cancel = new EventEmitter();
  @Output() confirmCancel = new EventEmitter();
  @Output() answerOffer = new EventEmitter<AnswerOfferEvent>();

  cancelOptionTitle: string;
  cancelOptionSubtitle: string;
  offerApplicableItem: QPilotOfferApplicableItem | null = null;
  selectedOption?: string;
  actionTrigger = QPilotActionTriggerTypes.Cancel;

  private confirmedSubject = new BehaviorSubject<boolean>(false);
  confirmed$ = this.confirmedSubject.asObservable();
  survey$: Observable<QPilotSurvey>;

  ngOnInit() {
    this.survey$ = this.confirmed$.pipe(
      switchMap((confirmed) => {
        if (confirmed) {
          return this.cancelSurvey$.pipe(
            tap(survey => !survey.id ? this.confirmCancel.emit() : null)
          )
        }
        return of(<QPilotSurvey>{})
      }),
    )

    const {
      scheduledOrderItems: items,
      frequencyDisplayName,
      shippingStreet1,
    } = this.order;

    this.cancelOptionTitle = `Cancel my ${this.orderVerboseName}`;
    this.cancelOptionSubtitle = `${items?.length} items ${frequencyDisplayName} to ${shippingStreet1}`;
  }

  onAnswerOffer(event: AnswerOfferEvent) {
    this.answerOffer.emit(event);
  }

  resetSurveyAndOffer() {
    this.selectedOption = undefined;
    this.confirmedSubject.next(false);
  }

  onCancel() {
    this.cancel.emit();
  }

  onConfirm() {
    this.confirmedSubject.next(true);
  }
}
